// removed by extract-text-webpack-plugin
module.exports = {"defalutColor":"defalutColor__298wq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortBtn/styles.scss
// module id = 2154
// module chunks = 1